import React from "react";
import { Link } from "react-router";

function Home() {
    return (
        <>
            <section id="employment" className="p-md-5">
                <div className="p-md-5">
                    <div className="text-section text-center p-md-5">
                        <h1>
                            School <span>to</span>
                            <br />
                            Employment
                        </h1>
                        <div className="">
                            <p className="p-3">
                                Unlock opportunities to gain hands-on experience <br />
                                and transition to full-time employment.
                            </p>
                            <Link id="req-demo" to={"/enroll-now"}>
                                ENROLL NOW{" "}
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <section id="internship" className="ecosystem-section py-5">
                <div className="container py-5">
                    {/* Section Title */}
                    <h2 className="fw-bold text-center">Internship Comes Employment</h2>
                    <p className="text-center">
                        Empowering students with real-world skils in IT development
                    </p>
                    {/* Features Grid */}
                    <div className="row mt-4">
                        {/* Feature 1 */}
                        <div className="col-sm-4">
                            <div className="card border-0 h-100">
                                <div className="card-body">
                                    <div className="feature-image bg-light rounded mb-3">
                                        <img
                                            src="https://play.toddleapp.com/wp-content/uploads/2023/03/Mask-group-58.webp"
                                            alt="Teaching & Learning Platform"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <h5 className="fw-bold">Basic</h5>
                                    <p className="text-muted">
                                        This plan includes the 45days of basic knowledge and
                                        learning about your course
                                    </p>
                                    <a href="#" className="text-decoration-none text-dark">
                                        <span className="fw-bold" style={{ fontSize: "xx-large" }}>
                                            →
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* Feature 2 */}
                        <div className="col-sm-4">
                            <div className="card border-0 h-100">
                                <div className="card-body p-4">
                                    <div className="feature-image bg-light rounded mb-3">
                                        <img
                                            src="	https://play.toddleapp.com/wp-content/uploads/2023/03/Mask-group-56-1.webp"
                                            alt="Child-centred Curriculum"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <h5 className="fw-bold">Intermediate</h5>
                                    <p className="text-muted">
                                        This plan includes the 3months of deep knowledge and
                                        learning about your course
                                    </p>
                                    <a href="#" className="text-decoration-none text-dark">
                                        <span className="fw-bold" style={{ fontSize: "xx-large" }}>
                                            →
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* Feature 3 */}
                        <div className="col-sm-4">
                            <div className="card border-0 h-100">
                                <div className="card-body p-4">
                                    <div className="feature-image bg-light rounded mb-3">
                                        <img
                                            src="	https://play.toddleapp.com/wp-content/uploads/2023/03/Mask-group-57-1.webp"
                                            alt="Ongoing Professional Development"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <h5 className="fw-bold">Expert</h5>
                                    <p className="text-muted">
                                        This plan includes the 6months of deep knowledge and
                                        learning about your course
                                    </p>
                                    <a href="#" className="text-decoration-none text-dark">
                                        <span className="fw-bold" style={{ fontSize: "xx-large" }}>
                                            →
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="good-company-section py-5">
                <div className="container text-center">
                    {/* Title */}

                    <h2 className="fw-bold">Our Interns Are Working With</h2>

                    {/* Carousel */}
                    <div className="carousel-wrapper">
                        <div className="carousel-content">
                            {/* Logos */}
                            <img
                                src={require("../assets/images/client1.png")}
                                className="carousel-logo"
                                alt="Logo 1"
                            />
                            <img
                                src={require("../assets/images/client2.png")}
                                className="carousel-logo"
                                alt="Logo 2"
                            />
                            <img
                                src={require("../assets/images/client3.png")}
                                className="carousel-logo"
                                alt="Logo 3"
                            />
                            <img
                                src={require("../assets/images/client4.png")}
                                className="carousel-logo"
                                alt="Logo 4"
                            />
                            <img
                                src={require("../assets/images/client5.png")}
                                className="carousel-logo"
                                alt="Logo 5"
                            />
                            <img
                                src={require("../assets/images/client6.png")}
                                className="carousel-logo"
                                alt="Logo 6"
                            />
                            <img
                                src={require("../assets/images/client7.png")}
                                className="carousel-logo"
                                alt="Logo 7"
                            />
                            <img
                                src={require("../assets/images/client8.png")}
                                className="carousel-logo"
                                alt="Logo 8"
                            />
                            {/* Duplicate for smooth loop */}
                            <img
                                src={require("../assets/images/client9.png")}
                                className="carousel-logo"
                                alt="Logo 1"
                            />
                            <img
                                src={require("../assets/images/client10.png")}
                                className="carousel-logo"
                                alt="Logo 2"
                            />
                            <img
                                src={require("../assets/images/client1.png")}
                                className="carousel-logo"
                                alt="Logo 3"
                            />
                            <img
                                src={require("../assets/images/client2.png")}
                                className="carousel-logo"
                                alt="Logo 4"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <div className="bg-light-light d-flex align-items-center px-3 py-5">
                <div className="container d-flex flex-column flex-md-row align-items-center justify-content-around position-relative py-md-5">
                    {/* Left Image Section */}
                    <div className="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                        <img
                            src={require("../assets/images/new trans.png")}
                            alt="School Library Screenshot"
                            className="img-fluid rounded shadow-custom"
                        />
                    </div>
                    {/* Right Content Section */}
                    <div className="content text-start text-md-start col-12 col-md-4">
                        <h2 className="fw-bold">Unlock your potential with MCL School.</h2>
                        <p className="text-muted">
                            MCL School brings everything you need to upskill – practical
                            training, collaborative projects, career guidance, and real-world
                            internships.
                        </p>
                        <a href="#" className="btn btn-outline-danger fw-bold px-4 py-2">
                            Learn More
                        </a>
                    </div>
                </div>
            </div>
            <div className="d-flex bg-light-blue align-items-center px-3 py-5">
                <div className="container d-flex flex-column flex-md-row align-items-center justify-content-around position-relative py-5">
                    <div className="content order-md-1 order-2 text-start text-md-start col-12 col-md-4">
                        <h2 className="fw-bold">Elevate learning, shape careers.</h2>
                        <p className="text-muted">
                            With an evolving suite of expert-designed training programs and
                            real-world internship opportunities, MCL School equips students
                            with the skills to succeed.
                        </p>
                        <a href="#" className="btn btn-outline-danger fw-bold px-4 py-2">
                            Learn More
                        </a>
                    </div>
                    {/* Left Image Section */}
                    <div className="col-12 order-md-2 order-1 col-md-4 text-center text-md-end mb-4 mb-md-0">
                        <img
                            src={require("../assets/images/Elevate.png")}
                            alt="School Library Screenshot"
                            className="img-fluid rounded shadow-custom"
                        />
                    </div>
                    {/* <img
    src="assets/images/side-img.png"
    alt="image"
    class="position-absolute home-ele1"
  />
  <img
    src="assets/images/side-img1.png"
    alt="image"
    class="position-absolute home-ele2"
  /> */}
                </div>
            </div>
            <div className="bg-light-light d-flex align-items-center px-3 py-5">
                <div className="container d-flex flex-column flex-md-row align-items-center justify-content-around position-relative py-md-5">
                    {/* Left Image Section */}
                    <div className="col-12 col-md-4 text-center text-md-start mb-2 mb-md-0">
                        <img
                            src={require("../assets/images/JobGuarantee.png")}
                            alt="School Library Screenshot"
                            className="img-fluid rounded shadow-custom"
                        />
                    </div>
                    {/* Right Content Section */}
                    <div className="content text-start text-md-start col-12 col-md-4">
                        <h2 className="fw-bold">100% Job Guarantee.</h2>
                        <p className="text-muted">
                            After the successful completion of six months of employment, the
                            candidate has gained valuable experience and is now fully prepared
                            to take on new challenges and transition to a job opportunity.
                        </p>
                        <a href="#" className="btn btn-outline-danger fw-bold px-4 py-2">
                            Learn More
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
